import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

import _ from "lodash";
import moment from "moment";
import dayjs from "dayjs";

const initialState = {
    instruksies_cards: {
        loading: true,
        success: false,
        error: false,
        errordata: null,
        data: [],
        initialData: []
    },
    datagekry: [],
    sien_instruksie_modal_open: false,
    datum: new Date(),
    view: "day",
    aktiewe_instruksie: {},
    selected: null,
    instruksies_filter: {},
    instruksies_search: "",
    instruksie_invul_loading: true,
    instruksie_invul_failed: {
        error: false,
        errordata: null
    },
    instruksie_invul_data_modal_open: false,
    instruksie_invul_data_modal_content: "",
    instruksie_invul_data: {},
    instruksie_invul_datums: [],
    instruksie_invul_selected_item: null
};

const setInstruksieCardsLoading = (state, action) => {
    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            loading: true,
        }
    });
};

const setInstruksiesCards = (state, action) => {
    var newCards = _.cloneDeep(action.cards);
    newCards = newCards.filter((itemvalue) => {
        return itemvalue.id.toString().indexOf(state.instruksies_search.toString()) !== -1;
    });
    if (Object.keys(state.instruksies_filter).length > 0 && state.instruksies_filter.constructor === Object) {
        let ids = action.ids;
        if (action.tipe === "aktiwiteit") {
            ids = action.ids.map(item => item.substring(1, item.indexOf("_") - 1));
            ids = [...new Set(ids)];
        }
        var filters = { ...state.instruksies_filter, [action.tipe]: ids };
        newCards = newCards.filter((itemvalue) => {
            let returnvalue = false;
            let kan = true;
            for (const [key, value] of Object.entries(filters)) {
                if (key === "aktiwiteit") {
                    let nuweid = itemvalue.taak[key].id.substring(1, itemvalue.taak[key].id.indexOf("_") - 1);
                    if (nuweid && value.indexOf(nuweid.toString()) === -1) {
                        kan = false;
                    }
                }
                if (key === "plaas") {
                    let nuweid = itemvalue.taak[key].id;
                    if (nuweid && value.indexOf(nuweid.toString()) === -1) {
                        kan = false;
                    }
                }
                if (key === "werknemer") {
                    if (value.filter(e => itemvalue.instruksieleiers.map(item => item.nuutstearbeidernr.toString()).includes(e)).length < 1 && value.filter(e => itemvalue.arbeiders.map(item => item.toString()).includes(e)).length < 1) {
                        kan = false;
                    }
                }
            }
            if (kan) {
                returnvalue = itemvalue;
            }
            return returnvalue;
        });
    }
    newCards = _.sortBy(newCards, 'datum');
    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            loading: false,
            success: true,
            error: false,
            errordata: null,
            data: newCards,
            initialData: action.cards
        }
    });
};

const getInstruksiesCardsFailed = (state, action) => {
    // console.log(action);
    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            loading: false,
            success: false,
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            },
            data: []
        }
    });
};

const openSienInstruksieModal = (state, action) => {
    return updateObject(state, {
        sien_instruksie_modal_open: true
    });
};

const closeSienInstruksieModal = (state, action) => {
    return updateObject(state, {
        sien_instruksie_modal_open: false
    });
};

const kiesInstruksie = (state, action) => {
    return updateObject(state, {
        aktiewe_instruksie: action.instruksie
    });
};

const setSelectedInstruksie = (state, action) => {
    return updateObject(state, {
        selected: action.instruksie
    });
};

const setInstruksieView = (state, action) => {
    return updateObject(state, {
        view: action.view
    });
};

const addDatum = (state, action) => {
    return updateObject(state, {
        datum: moment(state.datum).add(1, state.view)
    });
};

const subtractDatum = (state, action) => {
    return updateObject(state, {
        datum: moment.utc(moment(state.datum).subtract(1, state.view)).format()
    });
};

const setVandagDatum = (state, action) => {
    return updateObject(state, {
        datum: new Date()
    });
};

const setDatum = (state, action) => {
    return updateObject(state, {
        datum: moment(action.datum)
    });
};

const setInstruksieDatumsGekry = (state, action) => {
    return updateObject(state, {
        datagekry: action.datums
    });
};

const setInstruksiesFilter = (state, action) => {
    var newCards = _.cloneDeep(state.instruksies_cards.initialData);
    newCards = newCards.filter((itemvalue) => {
        return itemvalue.id.toString().indexOf(state.instruksies_search.toString()) !== -1;
    });
    let ids = action.ids;
    if (action.tipe === "aktiwiteit") {
        ids = action.ids.map(item => item.substring(1, item.indexOf("_") - 1));
        ids = [...new Set(ids)];
    }
    var filters = { ...state.instruksies_filter, [action.tipe]: ids };
    newCards = newCards.filter((itemvalue) => {
        let returnvalue = false;
        let kan = true;
        for (const [key, value] of Object.entries(filters)) {
            if (key === "aktiwiteit") {
                let nuweid = itemvalue.taak[key].id.substring(1, itemvalue.taak[key].id.indexOf("_") - 1);
                if (nuweid && value.indexOf(nuweid.toString()) === -1) {
                    kan = false;
                }
            }
            if (key === "plaas") {
                let nuweid = itemvalue.taak[key].id;
                if (nuweid && value.indexOf(nuweid.toString()) === -1) {
                    kan = false;
                }
            }
            if (key === "werknemer") {
                if (value.filter(e => itemvalue.instruksieleiers.map(item => item.nuutstearbeidernr.toString()).includes(e)).length < 1 && value.filter(e => itemvalue.arbeiders.map(item => item.toString()).includes(e)).length < 1) {
                    kan = false;
                }
            }
        }
        if (kan) {
            returnvalue = itemvalue;
        }
        return returnvalue;
    });

    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            data: newCards
        },
        instruksies_filter: {
            ...state.instruksies_filter,
            [action.tipe]: action.ids
        }
    });
};

const clearInstruksiesFilter = (state, action) => {
    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            data: state.instruksies_cards.initialData
        },
        instruksies_filter: {}
    });
};

const searchInstruksies = (state, action) => {
    var newCards = _.cloneDeep(state.instruksies_cards.initialData);
    newCards = newCards.filter((itemvalue) => {
        return itemvalue.id.toString().indexOf(action.data.toString()) !== -1;
    });
    if (Object.keys(state.instruksies_filter).length > 0 && state.instruksies_filter.constructor === Object) {
        newCards = newCards.filter((itemvalue) => {
            var returnvalue;
            for (const [key, value] of Object.entries(state.instruksies_filter)) {
                let ids;
                if (key === "aktiwiteit") {
                    ids = value.map(item => item.substring(1, item.indexOf("_") - 1));
                    ids = [...new Set(ids)];
                    for (const id of ids) {
                        let taakaktiwiteitid = itemvalue.taak[key].id;
                        if (taakaktiwiteitid.substring(1, taakaktiwiteitid.indexOf("_") - 1).toString() === id.toString()) {
                            returnvalue = itemvalue;
                        }
                    }
                }
                if (key === "plaas") {
                    for (const id of value) {
                        if (itemvalue.taak[key].id.toString() === id.toString()) {
                            returnvalue = itemvalue;
                        }
                    }
                }
                if (key === "werknemer") {
                    for (const id of value) {
                        if (itemvalue.arbeiders.indexOf(id.toString()) !== -1) {
                            returnvalue = itemvalue;
                        }
                        for (const ilid of itemvalue.instruksieleiers) {
                            if (ilid.id.toString() === id.toString()) {
                                returnvalue = itemvalue;
                            }
                        }
                    }
                }
            }
            return returnvalue;
        });
    }
    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            data: newCards
        },
        instruksies_search: action.data
    });
};

const clearInstruksiesCards = (state, action) => {
    return updateObject(state, {
        instruksies_cards: {
            ...state.instruksies_cards,
            data: []
        },
        datagekry: []
    });
};

const instrInvulStelDatums = (state, action) => {
    let nuweDatums = action.datums.map(item => new Date(item)).sort((a, b) => moment(a).diff(b));
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    for (const [key, value] of Object.entries(ouData)) {
        if (key === "arbeiders" || key === "instruksieleiers" || key === "VI" || key === "VIC" || key === "CF") {
            for (const item of value) {
                let keys = item.klokrekords ? Object.keys(item.klokrekords).filter(i => nuweDatums.map(it => moment(it).format("Y-MM-DD")).indexOf(i) !== -1) : [];
                nuut[key][value.map(i => i.id).indexOf(item.id)].klokrekords = _.pick(item.klokrekords, keys);
            }
        } else if (key === "T" || key === "V") {
            for (const [k, v] of Object.entries(value)) {
                for (const item of v.items) {
                    let keys = item.klokrekords ? Object.keys(item.klokrekords).filter(i => nuweDatums.map(it => moment(it).format("Y-MM-DD")).indexOf(i) !== -1) : [];
                    let kk = nuut[key][value.map(i => i.id).indexOf(v.id)].items;
                    nuut[key][value.map(i => i.id).indexOf(v.id)].items[kk.map(i => i.id).indexOf(item.id)].klokrekords = _.pick(item.klokrekords, keys);
                }
            }
        }
    }
    nuweDatums = nuweDatums.sort((a, b) => moment(a).diff(b));
    return updateObject(state, { instruksie_invul_datums: nuweDatums, instruksie_invul_data: nuut });
};

const instrInvulStelDatumsTye = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);

    let datum = moment(action.datum).format("Y-MM-DD");
    for (const [key, value] of Object.entries(ouData)) {
        if (key === "arbeiders" || key === "instruksieleiers") {
            for (const item of value) {
                let nuweTye;
                if (action.tye) {
                    nuweTye = {
                        in: { tyd: moment(datum + " " + dayjs(action.tye[0]).format("HH:mm"), "Y-MM-DD HH:mm") },
                        uit: { tyd: moment(datum + " " + dayjs(action.tye[1]).format("HH:mm"), "Y-MM-DD HH:mm") },
                    }
                }
                if (nuweTye) {
                    nuut[key][value.map(i => i.id).indexOf(item.id)].klokrekords[datum] = [nuweTye];
                } else {
                    delete nuut[key][value.map(i => i.id).indexOf(item.id)].klokrekords[datum];
                }
            }
        } else if (key === "T" || key === "V") {
            for (const [k, v] of Object.entries(value)) {
                for (const item of v.items) {
                    let kk = nuut[key][value.map(i => i.id).indexOf(v.id)].items;
                    let nuweTye;
                    if (action.tye) {
                        nuweTye = {
                            ...nuut[key][value.map(i => i.id).indexOf(v.id)].items[kk.map(i => i.id).indexOf(item.id)].klokrekords[datum],
                            in: { tyd: moment(datum + " " + dayjs(action.tye[0]).format("HH:mm"), "Y-MM-DD HH:mm") },
                            uit: { tyd: moment(datum + " " + dayjs(action.tye[1]).format("HH:mm"), "Y-MM-DD HH:mm") },
                        }
                    }
                    if (nuweTye) {
                        nuut[key][value.map(i => i.id).indexOf(v.id)].items[kk.map(i => i.id).indexOf(item.id)].klokrekords[datum] = [nuweTye];
                    } else {
                        delete nuut[key][value.map(i => i.id).indexOf(v.id)].items[kk.map(i => i.id).indexOf(item.id)].klokrekords[datum];
                    }
                }
            }
        }
    }
    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_data_modal_open: false,
        instruksie_invul_data_modal_content: ""
    });
};

const instrInvulRemoveRekord = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    delete nuut[action.afdeling][nuut[action.afdeling].map(item => item.id).indexOf(action.id)];
    nuut = {
        ...nuut,
        [action.afdeling]: nuut[action.afdeling].filter(item => item)
    }
    return updateObject(state, { instruksie_invul_data: nuut });
};

const instrInvulRemoveNestedRekord = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let index = nuut[action.afdeling].map(item => item.id).indexOf(action.nestedafdeling);
    delete nuut[action.afdeling][index].items[nuut[action.afdeling][index].items.map(item => item.id).indexOf(action.id)];
    let filtered = nuut[action.afdeling][index].items.filter(item => item);
    nuut[action.afdeling][index].items = filtered;
    return updateObject(state, { instruksie_invul_data: nuut });
};

const instrInvulStelRekordTyd = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let index = nuut[action.afdeling].map(item => item.id).indexOf(action.id);
    if (action.value != null) {
        let val = action.value.map(item => moment(action.datum + " " + dayjs(item).format("HH:mm"), "Y-MM-DD HH:mm"));
        if (action.klokid) {
            let i = nuut[action.afdeling][index].klokrekords[action.datum].map(item => item.id).indexOf(action.klokid);
            nuut[action.afdeling][index].klokrekords[action.datum][i].in.tyd = new Date(val[0]);
            nuut[action.afdeling][index].klokrekords[action.datum][i].uit.tyd = new Date(val[1]);
        } else {
            nuut[action.afdeling][index].klokrekords[action.datum] = [{
                in: { tyd: new Date(val[0]) },
                uit: { tyd: new Date(val[1]) }
            }];
        }
    } else {
        if (action.klokid) {
            let i = nuut[action.afdeling][index].klokrekords[action.datum].map(item => item.id).indexOf(action.klokid);
            nuut[action.afdeling][index].klokrekords[action.datum].splice(i, 1);
        } else {
            delete nuut[action.afdeling][index].klokrekords[action.datum];
        }
    }

    return updateObject(state, { instruksie_invul_data: nuut });
};

const instrInvulStelNestedRekordTyd = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let index = nuut[action.afdeling].map(item => item.id).indexOf(action.nestedafdeling);
    let secondindex = nuut[action.afdeling][index].items.map(item => item.id).indexOf(action.id);
    if (action.value != null) {
        let val = action.value.map(item => moment(action.datum + " " + dayjs(item).format("HH:mm"), "Y-MM-DD HH:mm"));
        if (action.klokid) {
            let i = nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum].map(item => item.id).indexOf(action.klokid);
            nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum][i].in.tyd = new Date(val[0]);
            nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum][i].uit.tyd = new Date(val[1]);
        } else {
            nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum] = [{
                in: { tyd: new Date(val[0]) },
                uit: { tyd: new Date(val[1]) }
            }];
        }
    } else {
        if (action.klokid) {
            let i = nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum].map(item => item.id).indexOf(action.klokid);
            nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum].splice(i, 1);
        } else {
            delete nuut[action.afdeling][index].items[secondindex].klokrekords[action.datum];
        }
    }

    return updateObject(state, { instruksie_invul_data: nuut });
};

const openInstrInvulDataModal = (state, action) => {
    return updateObject(state, {
        instruksie_invul_data_modal_open: true,
        instruksie_invul_failed: {
            error: false,
            errordata: null
        },
    });
};

const closeInstrInvulDataModal = (state, action) => {
    return updateObject(state, {
        instruksie_invul_data_modal_open: false,
        instruksie_invul_data_modal_content: "",
        instruksie_invul_selected_item: null,
        instruksie_invul_failed: {
            error: false,
            errordata: null
        },
    });
};

const instrInvulDataModalContent = (state, action) => {
    return updateObject(state, {
        instruksie_invul_data_modal_content: action.content
    });
};

const instrInvulAddArbeiders = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let nuwearbeiders = _.union(nuut[action.afdeling], action.arbeiders);
    nuwearbeiders = _.uniqBy(nuwearbeiders, "id");
    nuut[action.afdeling] = nuwearbeiders.map(item => {
        item.klokrekords = item.klokrekords || {};
        return item;
    });

    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_data_modal_open: false,
        instruksie_invul_data_modal_content: ""
    });
};

const instrInvulAddItemtipes = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let nuweitems = _.union(nuut[action.afdeling], action.ids);
    nuweitems = _.uniqBy(nuweitems, "id");
    nuut[action.afdeling] = nuweitems.map(item => {
        item.items = item.items || [];
        return item;
    });

    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_data_modal_open: false,
        instruksie_invul_data_modal_content: ""
    });
};

const instrInvulAddItems = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let index = nuut[action.afdeling].map(item => item.id).indexOf(action.nestedafdeling);
    let nuweitems = _.union(nuut[action.afdeling][index].items, action.ids);
    nuweitems = _.uniqBy(nuweitems, "id");
    nuut[action.afdeling][index].items = nuweitems.map(item => {
        item.klokrekords = item.klokrekords || {};
        return item;
    });

    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_data_modal_open: false,
        instruksie_invul_data_modal_content: ""
    });
};

const instrInvulAddVerbruiksItems = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let nuweitems = _.union(nuut[action.afdeling], action.ids);
    nuweitems = _.uniqBy(nuweitems, "id");
    nuut[action.afdeling] = nuweitems.map(item => {
        item.klokrekords = item.klokrekords || {};
        return item;
    });

    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_data_modal_open: false,
        instruksie_invul_data_modal_content: ""
    });
};

const instrInvulSetItemIdSelected = (state, action) => {
    return updateObject(state, {
        instruksie_invul_selected_item: action.id
    });
};

const instrInvulSetInstruksieLoading = (state, action) => {
    return updateObject(state, {
        instruksie_invul_loading: true,
    });
};

const instrInvulSetInstruksie = (state, action) => {
    let instruksie = action.value;
    let ouData = _.cloneDeep(instruksie);
    let nuut = _.cloneDeep(ouData);

    let datums = [new Date(moment(instruksie.datum).format("Y-MM-DD"))];
    let customfields = [];
    for (const [key, value] of Object.entries(ouData)) {
        if (key === "arbeiders" || key === "instruksieleiers" || key === "VI" || key === "VIC") {
            for (const item of value) {
                nuut[key][value.map(i => i.id).indexOf(item.id)].klokrekords = {};
            }
        } else if (key === "T" || key === "V") {
            for (const [k, v] of Object.entries(value)) {
                for (const item of v.items) {
                    let kk = nuut[key][value.map(i => i.id).indexOf(v.id)].items;
                    nuut[key][value.map(i => i.id).indexOf(v.id)].items[kk.map(i => i.id).indexOf(item.id)].klokrekords = {};
                }
            }
        } else if (key.startsWith("c_")) {
            customfields.push({
                id: key,
                klokrekords: {
                    [moment(instruksie.datum).format("Y-MM-DD")]: value
                }
            });
        }
    }
    if (customfields.length > 0) {
        nuut.CF = customfields;
    }

    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_loading: false,
        instruksie_invul_datums: datums,
    });
};

const instrInvulGetInstruksieFailed = (state, action) => {
    return updateObject(state, {
        instruksie_invul_loading: false,
        instruksie_invul_failed: {
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const instrInvulSetInstruksieIngevulLoading = (state, action) => {
    return updateObject(state, {
        instruksie_invul_loading: true
    });
};

const instrInvulSetInstruksieIngevul = (state, action) => {
    let datums = action.value.ingevul.datums.map(item => new Date(moment(item).format("Y-MM-DD"))).sort((a, b) => moment(a).diff(b));
    let nuut = _.extend({}, action.value.leeg, action.value.ingevul);

    return updateObject(state, {
        instruksie_invul_data: nuut,
        instruksie_invul_loading: false,
        instruksie_invul_datums: datums
    });
};

const instrInvulGetInstruksieIngevulFailed = (state, action) => {
    return updateObject(state, {
        instruksie_invul_loading: false,
        instruksie_invul_failed: {
            error: true,
            errordata: {
                easymessage: action.easymessage,
                status: action.status,
                message: action.message
            }
        }
    });
};

const instrInvulChangeCustomFieldValue = (state, action) => {
    let ouData = _.cloneDeep(state.instruksie_invul_data);
    let nuut = _.cloneDeep(ouData);
    let index = nuut[action.afdeling].map(item => item.id).indexOf(action.id);
    if (index !== -1) {
        if (action.klokid) {
            let i = nuut[action.afdeling][index].klokrekords[moment(action.datum).format("Y-MM-DD")].map(item => item.id).indexOf(action.klokid);
            console.log(i);
            nuut[action.afdeling][index].klokrekords[moment(action.datum).format("Y-MM-DD")][i === -1 ? 0 : i].aantal = action.value;
        } else {
            nuut[action.afdeling][index].klokrekords[moment(action.datum).format("Y-MM-DD")] = [{ aantal: action.value }];
        }
    } else {
        nuut[action.afdeling][0].klokrekords[moment(action.datum).format("Y-MM-DD")] = [{ aantal: action.value }];
    }

    return updateObject(state, {
        instruksie_invul_data: nuut,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_LOADING_INSTRUKSIES_CARDS:
            return setInstruksieCardsLoading(state, action);
        case actionTypes.SET_INSTRUKSIES_CARDS:
            return setInstruksiesCards(state, action);
        case actionTypes.GET_INSTRUKSIES_CARDS_FAILED:
            return getInstruksiesCardsFailed(state, action);
        case actionTypes.OPEN_SIEN_INSTRUKSIE:
            return openSienInstruksieModal(state, action);
        case actionTypes.CLOSE_SIEN_INSTRUKSIE:
            return closeSienInstruksieModal(state, action);
        case actionTypes.KIES_INSTRUKSIE:
            return kiesInstruksie(state, action);
        case actionTypes.SELECT_INSTRUKSIE:
            return setSelectedInstruksie(state, action);
        case actionTypes.INSTR_SET_VIEW:
            return setInstruksieView(state, action);
        case actionTypes.INSTR_ADD_DATUM:
            return addDatum(state, action);
        case actionTypes.INSTR_SUBTRACT_DATUM:
            return subtractDatum(state, action);
        case actionTypes.INSTR_SET_VANDAG:
            return setVandagDatum(state, action);
        case actionTypes.INSTR_SET_DATUM:
            return setDatum(state, action);
        case actionTypes.INSTR_SET_DATUMS_GEKRY:
            return setInstruksieDatumsGekry(state, action);
        case actionTypes.SET_INSTRUKSIES_FILTER:
            return setInstruksiesFilter(state, action);
        case actionTypes.CLEAR_INSTRUKSIES_FILTER:
            return clearInstruksiesFilter(state, action);
        case actionTypes.CLEAR_INSTRUKSIES_CARDS:
            return clearInstruksiesCards(state, action);
        case actionTypes.SEARCH_INSTRUKSIES:
            return searchInstruksies(state, action);
        case actionTypes.INSTR_INVUL_STEL_DATUMS:
            return instrInvulStelDatums(state, action);
        case actionTypes.INSTR_INVUL_STEL_DATUMS_TYE:
            return instrInvulStelDatumsTye(state, action);
        case actionTypes.INSTR_INVUL_REMOVE_REKORD:
            return instrInvulRemoveRekord(state, action);
        case actionTypes.INSTR_INVUL_REMOVE_NESTED_REKORD:
            return instrInvulRemoveNestedRekord(state, action);
        case actionTypes.INSTR_INVUL_STEL_REKORD_TYD:
            return instrInvulStelRekordTyd(state, action);
        case actionTypes.INSTR_INVUL_STEL_NESTED_REKORD_TYD:
            return instrInvulStelNestedRekordTyd(state, action);
        case actionTypes.INSTR_INVUL_DATA_OPEN:
            return openInstrInvulDataModal(state, action);
        case actionTypes.INSTR_INVUL_DATA_CLOSE:
            return closeInstrInvulDataModal(state, action);
        case actionTypes.INSTR_INVUL_DATA_MODAL_CONTENT:
            return instrInvulDataModalContent(state, action);
        case actionTypes.INSTR_INVUL_ADD_ARBEIDERS:
            return instrInvulAddArbeiders(state, action);
        case actionTypes.INSTR_INVUL_ADD_ITEMTIPES:
            return instrInvulAddItemtipes(state, action);
        case actionTypes.INSTR_INVUL_ADD_ITEMS:
            return instrInvulAddItems(state, action);
        case actionTypes.INSTR_INVUL_ADD_VERBRUIKSITEMS:
            return instrInvulAddVerbruiksItems(state, action);
        case actionTypes.INSTR_INVUL_SET_ITEM_ID_SELECTED:
            return instrInvulSetItemIdSelected(state, action);
        case actionTypes.INSTR_INVUL_SET_LOADING_INSTRUKSIE:
            return instrInvulSetInstruksieLoading(state, action);
        case actionTypes.INSTR_INVUL_SET_INSTRUKSIE:
            return instrInvulSetInstruksie(state, action);
        case actionTypes.INSTR_INVUL_GET_INSTRUKSIE_FAILED:
            return instrInvulGetInstruksieFailed(state, action);
        case actionTypes.INSTR_INVUL_GET_INSTRUKSIE_INGEVUL:
            return instrInvulSetInstruksieIngevulLoading(state, action);
        case actionTypes.INSTR_INVUL_SET_INSTRUKSIE_INGEVUL:
            return instrInvulSetInstruksieIngevul(state, action);
        case actionTypes.INSTR_INVUL_GET_INSTRUKSIE_INGEVUL_FAILED:
            return instrInvulGetInstruksieIngevulFailed(state, action);
        case actionTypes.INSTR_INVUL_CHANGE_CUSTOMFIELD_VALUE:
            return instrInvulChangeCustomFieldValue(state, action);
        default:
            return state;
    }
};

export default reducer;